"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusActionType = void 0;
var FocusActionType;
(function (FocusActionType) {
    FocusActionType[FocusActionType["SetFocus"] = 0] = "SetFocus";
})(FocusActionType = exports.FocusActionType || (exports.FocusActionType = {}));
//# sourceMappingURL=FocusActionType.js.map